import {IS_FORM_VALID} from '../actions/types';
import initialState from './initialState';

export default (prevState = initialState.inputField, action) => {
    switch(action.type) {

        case IS_FORM_VALID:
            const {isFormValid} = action.payload;
            let newState = {...prevState};
            newState.isFormValid = isFormValid;
            return newState;
        default:
            return prevState;

    }
}



// WEBPACK FOOTER //
// ./src/reducers/formInputReducer.js